import React from 'react';
import { Button } from '../ui-kit';
import PulseLoader from 'react-spinners/PulseLoader';

const loaderCss = { display: 'inline-block' };

const SaveButton = ({ hasUnsavedChanges, isSaving, onClick, label, style = 'success', className }) => {
  let text = null;
  if (label) {
    text = label; // override
  } else if (isSaving) {
    text = I18n.t('saving');
  } else if (hasUnsavedChanges) {
    text = I18n.t('save');
  } else {
    text = I18n.t('saved');
  }

  return (
    <Button
      variant={hasUnsavedChanges ? style : 'outline-secondary'}
      disabled={!hasUnsavedChanges || isSaving}
      className={className}
      onClick={onClick}
    >
      {text} {isSaving && <PulseLoader color="#417505" size="7px" css={loaderCss} />}
    </Button>
  );
};

export default SaveButton;
